const PageBanner = ({
  title,
  subtitle,
  crumb,
  className = "",
}) => (
  <section
    className={`rs-page-banner ${className}`}
    data-testid="page-banner"
  >
    <div className="container">
      <div className="rs-breadcrumb" data-aos="fade-up">
        <span>Home</span>

        <i className="bi bi-chevron-right"></i>

        <span className="active">{crumb}</span>
      </div>

      <h1 data-aos="fade-up" data-aos-delay="80">
        {title}
      </h1>

      {subtitle && (
        <p data-aos="fade-up" data-aos-delay="140">
          {subtitle}
        </p>
      )}
    </div>
  </section>
);

export default PageBanner;